import React from 'react'
import styled from 'styled-components'

export interface ITimeBoxProps {
    title: string
    onChange:(time: string) => void
    defaultValue: string
    hasError: boolean
}

const TimeBox: React.FC<ITimeBoxProps> = ({
    title,
    onChange,
    defaultValue,
    hasError
}) => {

    const className: string = hasError ? 'error' : ''

    return (
        <TimeBoxContainer>
            <BorderBox className={className}>
                <TimeInput 
                    type="time" 
                    id="appt" 
                    name="appt"
                    min="00:00"
                    max="23:59"
                    required
                    onChange={(event) => {onChange(event.target.value)}}
                    defaultValue={defaultValue.length > 0 ? defaultValue : undefined}
                />
            </BorderBox>
            <TitleLabel className={className}>{title}</TitleLabel>
        </TimeBoxContainer>
    )
}

const TimeBoxContainer = styled.div`
    position: relative;
    padding-top: 7px;
    height: 100%;
    flex: 1;
`

const BorderBox = styled.div`
    border: 1px solid ${({ theme }) => theme.color.greyer};
    width: 100%;
    height: 100%;
    padding: 14px;
    border-radius: 4px;
    text-align: center;

    &.error {
        border: 1px solid ${({ theme }) => theme.color.error};
    }
`

const TitleLabel = styled.div`
    position: absolute;
    top: 0;
    left: 14px;
    background-color: white;
    padding-left: 4px;
    padding-right: 4px;

    font-size: ${({ theme }) => theme.size.smaller};
    font-family: ${({ theme }) => theme.font.default};
    color: ${({ theme }) => theme.color.greyer};
    font-weight: ${({ theme }) => theme.weight.normal};

    &.error {
        color: ${({ theme }) => theme.color.error};
    }
`

const TimeInput = styled.input`
    font-size: ${({ theme }) => theme.size.small};
    font-family: ${({ theme }) => theme.font.default};
    color: ${({ theme }) => theme.color.black};
    font-weight: ${({ theme }) => theme.weight.normal};

    &::-webkit-calendar-picker-indicator {
        display: none;
    }
`

export default TimeBox
